export default __webpack_public_path__ + "5becde5.png";